module.exports = __webpack_public_path__ + "img/dzsw-03.453e95aa.png";